import { STATUS } from 'components/common/Toastify/Notify';
import { COMMON_CONSTANT, USER_LOGOUT } from 'model/constants/actionConstants';

// {
//   isShow: true,
//   type: STATUS.info,
//   msg: '',
// }
const setNotice = (data) => ({
	type: COMMON_CONSTANT.SET_NOTICE,
	payload: data,
});

const closeNotice = () => ({
	type: COMMON_CONSTANT.CLOSE_NOTICE,
	payload: {
		isShow: false,
		type: null,
		msg: null,
	},
});

const logout = () => ({
	type: USER_LOGOUT,
});

const showMessageModalError = (message) => (dispatch) => {
	dispatch(
		COMMON_ACTION.setNotice({
			isShow: true,
			type: STATUS.err,
			msg: message,
		})
	);
};

const showMessageModalInfo = (message) => (dispatch) => {
	dispatch(
		COMMON_ACTION.setNotice({
			isShow: true,
			type: STATUS.info,
			msg: message,
		})
	);
};

const showMessageModalSuccess = (message) => (dispatch) => {
	dispatch(
		COMMON_ACTION.setNotice({
			isShow: true,
			type: STATUS.success,
			msg: message,
		})
	);
};
const COMMON_ACTION = {
	setNotice,
	closeNotice,
	logout,
	showMessageModalError,
	showMessageModalInfo,
	showMessageModalSuccess,
};

export default COMMON_ACTION;
